import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import React, {useEffect, useState} from "react";
import ButtonAdd from "../button/ButtonAdd";
import ButtonExit from "../button/ButtonExit";
import TextFieldValidation from "../table/customer-detales/TextFieldValidation";

const emptyForm = {
    name: "",
    patternW: "",
    patternH: "",
    patternD: "",
}

const ModalDependentModuleComposition = ({
                                             open,
                                             onClose,
                                             handleSubmit,
                                             title = "Добавить",
                                             loading,
                                         }) => {
    const [formState, setFormState] = useState(emptyForm)
    const [validationState, setValidationState] = useState({name: ""})

    useEffect(() => {
        if (open) {
            setFormState(emptyForm)
            setValidationState({name: ""})
        }
    }, [open])

    const handleClose = () => {
        setFormState(emptyForm)
        setValidationState({name: ""})
        onClose()
    }

    const handleValidationData = () => {
        const nameError = formState.name ? "" : "пустое поле"
        setValidationState({name: nameError})
        if (nameError) {
            return
        }
        handleSubmit(formState, handleClose)
    }

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "400px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent>
                <TextFieldValidation
                    name={"name"}
                    type={"text"}
                    value={formState?.name}
                    label={"Наименование"}
                    setCurrValues={setFormState}
                    validationError={validationState?.name}
                    setValidationState={setValidationState}
                />
                <TextFieldValidation
                    name={"patternW"}
                    type={"text"}
                    value={formState?.patternW}
                    label={"Паттерн ширины"}
                    setCurrValues={setFormState}
                    required={false}
                />
                <TextFieldValidation
                    name={"patternH"}
                    type={"text"}
                    value={formState?.patternH}
                    label={"Паттерн высоты"}
                    setCurrValues={setFormState}
                    required={false}
                />
                <TextFieldValidation
                    name={"patternD"}
                    type={"text"}
                    value={formState?.patternD}
                    label={"Паттерн глубины"}
                    setCurrValues={setFormState}
                    required={false}
                />
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd loading={loading} text={"Добавить"} onClick={handleValidationData}/>
            </DialogActions>
        </Dialog>
    )
}

export default ModalDependentModuleComposition
